/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: speedDialsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Applications module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteSpeedDial } from './api/speedDialsApi';

/**
 * Shared helpers for Speed Dials module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Speed Dial entry in the form.
 * Pattern: /pbx/applications/speed-dialing/new?duplicate={id}
 */
export const getSpeedDialDuplicateUrl = (id: string | number): string =>
  `/pbx/applications/speed-dialing/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Speed Dial id.
 */
export const navigateToSpeedDialDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getSpeedDialDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Speed Dial entry by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteSpeedDial from api/speedDialsApi.ts instead
 */
export const deleteSpeedDialById = async (id: string | number): Promise<void> => {
  await deleteSpeedDial(id);
};



